import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems = [];
  menuItems1 = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(private eventService: EventService, private router: Router, public translate: TranslateService, private http: HttpClient) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    let menus = localStorage.getItem('menus');
    let permissions = localStorage.getItem('permissions');
    this.menuItems = this.appendAdminMailNotificationMenu(this.convertMenu(JSON.parse(menus), JSON.parse(permissions)));
    this.menuItems1 = []; //MENU
  }
  mapIcon(icon: string): string {
    const iconMap: any = {
      'fa fa-dashboard': 'bx-home-circle',
      'fa fa-user-circle': 'bx-user-circle',
      'fa fa-briefcase': 'bx-briefcase',
      'fa fa-building-o': 'bx-buildings',
      'fa fa-sliders': 'bx-slider-alt',
    };

    return iconMap[icon] || 'bx-circle';
  }
  convertMenu(apiMenus: any[], apiPermission: any[]): any[] {
    apiMenus = this.filterMenusByPermission(apiMenus, apiPermission);
    return apiMenus.map(menu => this.convertMenuItem(menu));
  }
  filterMenusByPermission(apiMenus, apiPermission) {
     let role = localStorage.getItem('roleNames');
    role = JSON.parse(role)[0];
    if (!apiPermission[role]) return [];

    // Extract unique module names from permissions
    const allowedModules = [
      ...new Set(
        apiPermission[role].map(p => {
          const lastIndex = p.lastIndexOf("_");
          return p.substring(0, lastIndex);
        })
      )
    ];

    function filterMenuList(menus) {
      return menus
        .map(menu => {
          // Clone menu to avoid mutation
          const newMenu = { ...menu };

          // Recursively filter submenu if exists
          if (Array.isArray(newMenu.submenu) && newMenu.submenu.length > 0) {
            newMenu.submenu = filterMenuList(newMenu.submenu);
          }

          // Keep menu if:
          // 1. Its label is allowed
          // 2. OR it has allowed submenus
          if (
            allowedModules.includes(newMenu.label.trim()) ||
            (newMenu.submenu && newMenu.submenu.length > 0)
          ) {
            return newMenu;
          }

          return null;
        })
        .filter(Boolean);
    }

    return filterMenuList(apiMenus);
  }

  private convertMenuItem(menu: any): any {
    const converted: any = {
      id: menu.id,
      label: menu.text,
      icon: this.mapIcon(menu.icon)
    };

    // if submenu exists and has items → recurse
    if (menu.submenu && menu.submenu.length > 0) {
      converted.subItems = menu.submenu.map((child: any) =>
        this.convertMenuItem(child)
      );
    } else if (menu.link && menu.link !== '#') {
      // leaf node
      converted.link = menu.link;
    }

    return converted;
  }

  private appendAdminMailNotificationMenu(items: any[]): any[] {
    const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
    const isAdmin = (roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('admin'));
    if (!isAdmin) {
      return items;
    }

    if (this.hasMenuLink(items, '/admin/mail-notifications')) {
      return items;
    }

    const adminParent = (items || []).find((item: any) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: any) => String(child?.link || '').startsWith('/admin/'))
    );

    const menuItem = {
      id: 'admin-mail-notifications',
      label: 'Mail Notification',
      icon: 'bx-envelope',
      link: '/admin/mail-notifications'
    };

    if (adminParent) {
      adminParent.subItems = [...(adminParent.subItems || []), menuItem];
      return items;
    }

    return [...(items || []), menuItem];
  }

  private hasMenuLink(items: any[], link: string): boolean {
    return (items || []).some((item: any) =>
      item?.link === link || this.hasMenuLink(item?.subItems || [], link)
    );
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
